import React from 'react';
import PageWrapper from './PageWrapper';
import EditableText from './EditableText';

export default function AppendixIntroPage({ data, personName }) {
  return (
    <PageWrapper pageNumber={16} personName={personName}>
      <h2 className="pdf-section-heading">
        <span className="pdf-section-heading__badge">8</span>
        <EditableText
          as="span"
          path="ratingsOnEachBehavior.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path="ratingsOnEachBehavior.pageDetails"
        variant="block"
      />

      <table className="pdf-table pdf-table--consensus">
        <thead>
          <tr>
            <th>
              <EditableText
                as="span"
                path="ratingsOnEachBehavior.consensusTableHeaders.left"
                variant="inline"
                stripInlineWrap
              />
            </th>
            <th>
              <EditableText
                as="span"
                path="ratingsOnEachBehavior.consensusTableHeaders.right"
                variant="inline"
                stripInlineWrap
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr><td>0 to 0.29</td><td>High</td></tr>
          <tr><td>0.3 to 0.89</td><td>Medium</td></tr>
          <tr><td>&ge; 0.9</td><td>Low</td></tr>
        </tbody>
      </table>

      <EditableText
        as="div"
        className="pdf-body-text"
        path="ratingsOnEachBehavior.lowConsensus"
        variant="block"
      />
      <EditableText
        as="p"
        className="pdf-note"
        path="ratingsOnEachBehavior.asteriskNote"
        variant="block"
        stripInlineWrap
      />
    </PageWrapper>
  );
}
